import dayjs from 'dayjs'
import { nanoid } from 'nanoid'

class ModelFactory {
  constructor() {
    this.today = dayjs().date(1).format('MM/DD/YYYY')
  }

  create(model) {
    if (model === 'education') return this.createEducation()

    if (model === 'work') return this.createWork()

    if (model === 'link') return this.createLink()

    if (model === 'language') return this.createLanguage()

    if (model === 'skill') return this.createSkill()

    if (model === 'course') return this.createCourse()

    if (model === 'project') return this.createProject()

    return this.createEducation()
  }

  createEducation() {
    const newModel = {
      institution: '',
      degree: '',
      location: '',
      description: '',
      period: {
        startDate: this.today,
        endDate: this.today,
        currently: false,
        disabled: false,
      },
      key: nanoid(),
    }

    return newModel
  }

  createWork() {
    const newModel = {
      company: '',
      position: '',
      location: '',
      summary: '',
      period: {
        startDate: this.today,
        endDate: this.today,
        currently: false,
        disabled: false,
      },
      key: nanoid(),
    }

    return newModel
  }

  createLink() {
    const newModel = {
      label: '',
      url: '',
      key: nanoid(),
    }

    return newModel
  }

  createLanguage() {
    const newModel = {
      language: '',
      fluency: '',
      key: nanoid(),
    }

    return newModel
  }

  createSkill() {
    const newModel = {
      name: '',
      level: 'novice',
      key: nanoid(),
    }

    return newModel
  }

  createCourse() {
    const newModel = {
      institution: '',
      course: '',
      period: {
        startDate: this.today,
        endDate: this.today,
        currently: false,
        disabled: false,
      },
      key: nanoid(),
    }

    return newModel
  }

  createProject() {
    const newModel = {
      title: '',
      location: '',
      summary: '',
      period: {
        startDate: this.today,
        endDate: this.today,
        currently: false,
        disabled: false,
      },
      key: nanoid(),
    }

    return newModel
  }
}

export default ModelFactory
